import i from '@/utils/request'
import {qs} from '../../utils'

export const home = {
  getMakeshow: params => i.get('/api/v1/bi/dashboard/makeshow', {params}),
  getSeason: params => i.get('/api/v1/bi/dashboard/makeshow/flame', {params}),

  //新增大屏数据接口更换
  getKanInfo: params => i.get(process.env.VUE_APP_JJAPI_API + '/api/v2/bi/dashboard/data_kanban_info', {params}),
  getdetailfo: params => i.get(process.env.VUE_APP_JJAPI_API+'/api/v2/bi/dashboard/daily_bill/detail', {params})

}
export const monthly = {
  getMonthlyList: params => i.get(process.env.VUE_APP_JJAPI_API + '/api/v1/bi/sales/monthpaper', {params})
}

export const day = {
  getDayList: params => i.get('api/v1/bi/sales/dailypaper', {params})
}

export const logistics = {
  getLogisticsDayList: params => i.get(process.env.VUE_APP_JJAPI_API + '/logistics/api/v1/express_daily_report_list' + qs(params))
}
